import { render, staticRenderFns } from "./journalTable.vue?vue&type=template&id=3af884a3&lang=pug"
import script from "./journalTable.vue?vue&type=script&lang=js"
export * from "./journalTable.vue?vue&type=script&lang=js"
import style0 from "./journalTable.vue?vue&type=style&index=0&id=3af884a3&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports